import React from "react";
import LanguageSelector from './LanguageSelector';

export default function Header({ onLogoClick }) {
  return (
    <nav className="fixed w-full bg-white border-b border-gray-200 z-50">
      <div className="container">
        <div className="flex justify-between items-center py-3">
          {/* Logo als Home-Button */}
          <button 
            onClick={onLogoClick}
            className="flex items-center hover:scale-105 transition-transform duration-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 rounded-lg p-1"
            aria-label="Zur Startseite"
          >
            <img src="/1CENTEO.png" alt="Centeo Logo" className="h-10 animate-float" />
          </button>

          {/* Language Dropdown */}
          <LanguageSelector />
        </div>
      </div>
    </nav>
  );
}
